import React from "react";
import "../styles/GameCard.css";

function GameCard({ title, image, url, description, buttonLabel, badge, backdrop, featured = false }) {
  return (
    <article
      className={`game-card ${featured ? "featured" : ""}`}
      style={backdrop ? { "--backdrop": `url(${backdrop})` } : undefined}
    >
      <a className="game-art" href={url} target="_blank" rel="noopener noreferrer" tabIndex={-1} aria-hidden="true">
        <img src={image} alt="" />
      </a>

      <div className="game-info">
        {badge && <span className="game-badge">{badge}</span>}
        <h3>{title}</h3>
        <p>{description}</p>
        <a
          className={`button ${featured ? "" : "button-secondary"}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="mask-icon" style={{ "--icon": "url(/images/icons/steam-glyph.png)" }} />
          {buttonLabel}
        </a>
      </div>
    </article>
  );
}

export default GameCard;
